import React, {useEffect} from 'react';
import * as S from './Success.styles';

import {logPageLoadEvents} from '@ibibo/analytics';

import IconSelector from '@ibibo/icon-selector';

const RegisterSuccess = () => {

  useEffect(() => {
    logPageLoadEvents('leadform:leadsubmitted', {});
  }, []);

  return (
    <S.SuccessMsgWrap>
      <S.CheckCircleWrap>
        <IconSelector iconKey='tickmarkwhite' props={{width: '3rem', height: '3rem'}} />
      </S.CheckCircleWrap>
      <S.SuccessMsgText>Thank you for showing your interest in <br />myPartner.</S.SuccessMsgText>
      <S.InfoText>Our team will reach out to you shortly</S.InfoText>
    </S.SuccessMsgWrap>
  );
}

export default RegisterSuccess;